import {
  RangerEvents,
  RangerEventSupportRequests,
  RangerSupportRequestUpdates
} from "@/prisma/generated/browser";

export type Notification = {
  id?: number;
  type: string;
  title: string;
  message: string;
  destination: string;
};

export enum NotificationType {
  Chat = "chat",
  CompletionReport = "completionReport",
  Generic = "generic"
}

export type RangerTier = {
  name: string;
  tier: number;
  min: number;
  max: number;
};

export type RangerStatus = {
  points: number;
  tier: RangerTier;
};

export enum RangersStatus {
  Pending = "Pending",
  Accepted = "Accepted",
  Declined = "Declined",
  Update = "Update"
}

export type EventWithSupportRequest = RangerEvents & {
  host: any;
  hostTier?: string;
  supportRequest: RangerEventSupportRequests & {
    updates: RangerSupportRequestUpdates[];
  };
};
